// デフォルトエラーコード
// 正常終了時はこのコード値を返す
export const ERRORCODE_DEFAULT = 0
// バックエンド単項目（内部項目）　エラーコード
export const ERRORCODE_SIMPLEITEM = 11
// バックエンド単項目（入力項目）　エラーコード
export const ERRORCODE_INPUTSIMPLEITEM = 12
// バックエンド相関入力　エラーコード
export const ERRORCODE_CORRECTION = 13
// バックエンド相関入力　エラーコード
export const ERRORCODE_INPUTCORRECTION = 14
// バックエンドシステムエラーコード
export const ERRORCODE_SYSTEM = 15
// バックエンドDBエラーコード
export const ERRORCODE_DB = 16



// WEBPACK FOOTER //
// ./src/components/Utility/error-codes.js